import { render, staticRenderFns } from "./MessageInfo.vue?vue&type=template&id=1685875a&"
import script from "./MessageInfo.vue?vue&type=script&lang=js&"
export * from "./MessageInfo.vue?vue&type=script&lang=js&"
import style0 from "./MessageInfo.vue?vue&type=style&index=0&id=1685875a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports